import NextImage, { ImageProps } from 'next/image';
// @mui
import { Theme } from '@mui/material/styles';
import { Box, BoxProps, SxProps } from '@mui/material';

// ----------------------------------------------------------------------

export type ImageRatio = '4/3' | '3/4' | '6/4' | '4/6' | '16/9' | '9/16' | '21/9' | '9/21' | '1/1';

type Props = ImageProps & {
  sx?: SxProps<Theme>;
  ratio?: ImageRatio;
  disabledEffect?: boolean;
  boxProps?: BoxProps;
};

export default function NextFutureImage({
  ratio,
  placeholder = 'blur',
  blurDataURL = '/assets/overlay.svg',
  disabledEffect = false,
  sx,
  alt = '',
  boxProps,
  ...imageProps
}: Props) {
  if (ratio) {
    return (
      <Box
        component="span"
        sx={{
          width: 1,
          lineHeight: 0,
          display: 'block',
          overflow: 'hidden',
          position: 'relative',
          pt: getRatio(ratio),
          '& .wrapper': {
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            lineHeight: 0,
            position: 'absolute',
            backgroundSize: 'cover !important',
          },
          ...sx,
        }}
        {...boxProps}
      >
        <NextImage alt={alt} style={{ maxWidth: '100%', objectFit: 'cover' }} {...imageProps} />
      </Box>
    );
  }

  return (
    <Box
      component="span"
      sx={{
        lineHeight: 1,
        display: 'block',
        overflow: 'hidden',
        '& .wrapper': { width: '100%', backgroundSize: 'cover !important' },
        ...sx,
      }}
      {...boxProps}
    >
      <NextImage
        alt={alt}
        style={{ maxWidth: '100%', height: '100%', objectFit: 'cover', borderRadius: '5px' }}
        {...imageProps}
      />
    </Box>
  );
}
// ----------------------------------------------------------------------

function getRatio(ratio = '1/1') {
  return {
    '4/3': 'calc(100% / 4 * 3)',
    '3/4': 'calc(100% / 3 * 4)',
    '6/4': 'calc(100% / 6 * 4)',
    '4/6': 'calc(100% / 4 * 6)',
    '16/9': 'calc(100% / 16 * 9)',
    '9/16': 'calc(100% / 9 * 16)',
    '21/9': 'calc(100% / 21 * 9)',
    '9/21': 'calc(100% / 9 * 21)',
    '1/1': '100%',
  }[ratio];
}
